export default __webpack_public_path__ + "static/media/AWS.2fa1fd9b.png";